import React from "react";

export default function NavBar() {
  return (
    <div className="nav-bar">
      <a className="title nav-btn" href="#home">
        HOME
      </a>
      <a className="title nav-btn" href="#software">
        SOFTWARE
      </a>
      <a className="title nav-btn" href="#hardware">
        HARDWARE
      </a>
      <a className="title nav-btn" href="#about">
        ABOUT ME
      </a>
    </div>
  );
}
